import { WaveSurferAudioPlayer } from "@circle-react-shared/uikit/TipTap/VoiceMessage/WaveSurferAudioPlayer";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { NodeViewWrapper } from "@tiptap/react";
import type { MouseEventHandler } from "react";

import { CloseButton } from "./CloseButton";

interface VoiceMessageRendererProps {
  attachment: any;
  isEditable: boolean;
  onDelete: MouseEventHandler<HTMLButtonElement>;
}

export const VoiceMessageRenderer = ({
  attachment,
  isEditable,
  onDelete,
}: VoiceMessageRendererProps) => (
  <NodeViewWrapper
    as="div"
    className={classNames("w-full", {
      "max-w-[317px]": !isEditable,
      "max-w-[327px] pr-2.5 pt-2.5": isEditable,
    })}
  >
    <div id="file-wrapper" className="group relative max-w-[317px] ring-inset">
      {isEditable && <CloseButton onClick={onDelete} />}
      <WaveSurferAudioPlayer
        src={attachment.url}
        isVoiceMessage
        transcriptionId={attachment.metadata?.transcript_id}
        transcriptionPreview={attachment.metadata?.transcript_preview}
      />
    </div>
  </NodeViewWrapper>
);
